import AlertFilled from './src/alert-filled';
export default AlertFilled;